import useFetchData from '../../../../../hooks/fetchHook';

const initialActivityLimit_ = 10;
const params_ = {
  limit: initialActivityLimit_,
  offset: 0,
};

export const useGetAuthenticationActivity = params => {
  const [{ data, isLoading = true, isError, error }, _, getActivity] =
    useFetchData('cases/authentication_activity', {
      formatter: format,
      params: params ?? params_,
    });

  return {
    data,
    isLoading,
    isError,
    error,
    getActivity,
  };
};

export const format = data => {
  return data.map(activity => formatActivity(activity));
};

const formatActivity = activity => {
  const {
    brand_image: brandLink,
    content: message,
    date: time,
    reference_id: itemId,
    type,
    user_image: userLink,
    user_name: name,
  } = activity;

  const brandImage = brandLink?.includes('null') ? null : brandLink;
  const userImage = userLink?.includes('null') ? null : userLink;

  return { image: userImage ?? brandImage, message, name, itemId, time, type };
};
